/* build/tpl */
import deps from './deps/paths.js';
import getPaths from './getPaths.js';
export default getPaths(deps);
